import type { FieldId, FieldValueType, SelfServiceTaskForm } from "../types";

/**　フォーム初期値管理用インターフェース */
export interface FormInitialValueProvider {
  /** 現在の初期値を取得（優先順位付き） */
  getInitialValues(): Record<FieldId, FieldValueType>;

  /** 初期値を更新（楽観的更新や送信時の値を保持するため） */
  updateInitialValues(values: Record<FieldId, FieldValueType>): void;
}

/**
 * 優先順位付きマージ
 * 優先順位: 外部値(楽観的更新後のAPI cache値や送信時の値) > フォーム定義値(APIから取得した値)
 */
function mergeInitialValues(
  formDefinitionValues: Record<FieldId, FieldValueType>,
  externalValues?: Record<FieldId, FieldValueType>,
): Record<FieldId, FieldValueType> {
  if (externalValues && Object.keys(externalValues).length > 0)
    return { ...externalValues };
  return { ...formDefinitionValues };
}

/**
 * フォーム初期値プロバイダーを作成する
 *
 * @param formDefinition フォーム定義
 * @param externalValues 外部から渡された初期値(楽観的更新後のAPI cache値や直前に送信した値)
 * @returns 初期値管理インスタンス
 */
export function createInitialValueProvider(
  formDefinition: SelfServiceTaskForm,
  externalValues?: Record<FieldId, FieldValueType>,
): FormInitialValueProvider {
  let currentValues = mergeInitialValues(
    formDefinition.formValues || {},
    externalValues,
  );
  return {
    getInitialValues: () => ({ ...currentValues }),
    updateInitialValues: (values) => {
      currentValues = mergeInitialValues(currentValues, values);
    },
  };
}
